import { physAndElmts } from "../../configs";
import { findCharacter } from "../../data/controllers";
import monsters from "../../data/monsters";

export function initCharInfo(info) {
  return {
    level: info.level || "1/20",
    ascension: info.ascension || 0,
    "Normal Attack": info["Normal Attack"] || 1,
    "Elemental Skill": info["Elemental Skill"] || 1,
    "Elemental Burst": info["Elemental Burst"] || 1,
    constellation: info.constellation || 0
  };
}

export function initWeapon({ type, code }) {
  const df = { Bow: 11, Catalyst: 36, Claymore: 59, Polearm: 84, Sword: 108 };
  return { type, code: code || df[type], level: "1/20", refinement: 1 };
}

export function initArtPiece({ type, code, rarity }) {
  return {
    type,
    code,
    rarity,
    level: 0,
    mainSType: type === "flower" ? "HP" : type === "plume" ? "ATK" : "ATK%",
    subS: [
      { type: "DEF", val: 0 },
      { type: "DEF%", val: 0 },
      { type: "CRIT Rate", val: 0 },
      { type: "CRIT DMG", val: 0 }
    ]
  };
}

export function initCharMCs(name, forSelf) {
  const result = { BCs: [], DCs: [] };
  const { buffs, debuffs } = findCharacter({ name });
  if (buffs) {
    for (const buff of buffs) {
      if (!buff.outdated && buff.affect !== (forSelf ? "teammates" : "self")) {
        const node = { activated: false, index: buff.index };
        if ((forSelf && buff.selfLabels) || (!forSelf && buff.labels)) {
          node.inputs = [...buff.inputs];
        }
        result.BCs.push(node);
      }
    }
  }
  // v2.4 - debuffs need inputs:
  // From self: AnemoMC C6 & Venti C6
  // Not from self: Eula E & Shenhe Q
  function getInputs(labels, inputTypes) {
    const inputs = [];
    labels.forEach((_, i) => {
      const type = inputTypes[i];
      if (type === "absorption") {
        inputs.push("Pyro");
      } else if (type === "text") {
        inputs.push(1); // level
      }
    });
    return inputs;
  }
  if (debuffs) {
    for (const debuff of debuffs) {
      if (debuff.outdated || (!forSelf && debuff.affect === "self")) {
        continue;
      }
      const node = { activated: false, index: debuff.index };
      const { selfLabels, labels, inputTypes } = debuff;
      if (forSelf && selfLabels) {
        node.inputs = getInputs(selfLabels, inputTypes);
      } else if (!forSelf && labels) {
        node.inputs = getInputs(labels, inputTypes);
      }
      result.DCs.push(node);
    }
  }
  return result;
}

export const initSubWpMCs = () => ({ BCs: {}, DCs: {} });

export const initParty = () => [null, null, null];

export const initElmtMCs = () => ({
  naAmpRxn: null,
  ampRxn: null,
  superconduct: false,
  spread: false,
  aggravate: false,
  resonance: []
});

export const initCustomMCs = () => ({ BCs: [], DCs: [] });

export const initMonster = () => ({
  name: monsters[0].name,
  inputs: []
});

export function initTarget() {
  const result = { Level: 1 };
  for (const elmt of physAndElmts) {
    result[elmt + " RES"] = 10;
  }
  return result;
}
